import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, CONTACT } from "./data";
import { scrollToId } from "./SmoothScroll";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 2.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-obsidian/75 backdrop-blur-xl border-gold/15" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo testId="nav-logo" />
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="nav-link font-mono text-[11px] uppercase tracking-[0.25em] text-ivory/80 hover:text-ivory">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a data-testid="btn-nav-booking" href={CONTACT.treatwell} target="_blank" rel="noreferrer" className="btn-gold hidden sm:inline-flex">
            Prenota <ArrowUpRight className="w-4 h-4" />
          </a>
          <button data-testid="nav-menu-toggle" aria-label="Menu" onClick={() => setOpen((v) => !v)} className="lg:hidden w-11 h-11 grid place-items-center rounded-full border border-gold/30 text-ivory">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            animate={{ clipPath: "inset(0 0 0% 0)" }}
            exit={{ clipPath: "inset(0 0 100% 0)" }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
            className="lg:hidden bg-obsidian border-b border-gold/20 px-5 pb-8 pt-2"
          >
            {NAV.map(([id, label], i) => (
              <button key={id} data-testid={`mobile-nav-link-${id}`} onClick={() => go(id)} className="flex w-full items-baseline gap-4 py-3 border-b border-white/5 text-left">
                <span className="font-mono text-[11px] text-gold">0{i + 1}</span>
                <span className="font-display text-3xl text-ivory">{label}</span>
              </button>
            ))}
            <a data-testid="mobile-treatwell-link" href={CONTACT.treatwell} target="_blank" rel="noreferrer" className="btn-gold mt-6 w-full justify-center">
              Prenota su Treatwell <ArrowUpRight className="w-4 h-4" />
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
